module.exports = __webpack_public_path__ + "img/500-error.cdedd0c.png";